import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

const StripePaymentBox = ({ savedCards = [], clientSecret, isDarkMode, payResponse }) => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);

    const options = {
        clientSecret,
        appearance: { theme: 'stripe' },
    };

    return (
        <div className="w-full mx-auto mt-4">
            {clientSecret ? (
                <Elements stripe={stripePromise} options={options}>
                    <CheckoutForm 
                        savedCards={savedCards} 
                        isDarkMode={isDarkMode} 
                        payResponse={payResponse}
                        clientSecret={clientSecret}
                    />
                </Elements>
            ) : (
                <p className="text-center">Loading payment form...</p>
            )}
        </div>
    );
};

export default StripePaymentBox;